<forge-scaffold>
    <div slot="body" class="conn-group-action--dropdown" fxLayout="column" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <forge-select *ngIf="ConnGroupList" autofocus label="Connection Group" [density]="density"
                          [disabled]="connGroupDisabled" [value]="ConnGroupID" (change)="updateConnGroup($event.detail)"
                          (keydown)="selectKeyUp($event)" aria-label="Conn-Group">
                <forge-option *ngFor="let item of ConnGroupList" [value]="item.Value">
                    {{item.Display}}
                </forge-option>
            </forge-select>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between">
            <forge-checkbox [checked]="updateConnGroupDefault" (change)="checked($event)"
                            [disabled]="connGroupDisabled">
                Set as Default Connection at Login
            </forge-checkbox>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between">
            <forge-select *ngIf="DepartmentList" label="Department" [value]="DepartmentID"
                          [disabled]="departmentDisabled" (change)="updateDepartment($event.detail)"
                          (keydown)="selectKeyUp($event)" [density]="density" aria-label="Department">
                <forge-option *ngFor="let item of DepartmentList" [value]="item.Value">
                    {{item.Display}}
                </forge-option>
            </forge-select>
        </div>
    </div>

    <forge-toolbar no-border slot="footer">
        <forge-button slot="end" variant="outlined" (click)="cancel()" telemetry="Submission-ConnGroupCancel">
            Cancel
        </forge-button>

        <forge-button slot="end" variant="raised" (click)="save()" [disabled]="!canSave"
                      telemetry="Submission-ConnGroupSave" style="margin-left:1em;">
            Save
        </forge-button>
    </forge-toolbar>
</forge-scaffold>